<template>
  <div v-loading="loading">
    <el-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      label-width="120"
      label-position="left"
    >
      <!-- 借款信息 -->
      <div class="flow-sub-title">借款信息</div>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="客户名称" v-if="getIsShow('customerName')">
            <span>{{ info.customerName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号" v-if="getIsShow('customerPhone')">
            <span>{{ info.customerPhone }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号" v-if="getIsShow('idCard')">
            <span>{{ info.idCard }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品名称" v-if="getIsShow('productName')">
            <span>{{ info.productName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品类型" v-if="getIsShow('productType')">
            <span>{{ productTypeText(info.productType) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申请借款金额" v-if="getIsShow('drawingAmount')">
            <span>{{ info.drawingAmount }}元</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="已放款金额" v-if="getIsShow('amountLent')">
            <span>{{ info.amountLent }}元</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="剩余可放款金额" v-if="getIsShow('surplusLoanMoney')">
            <span>{{ info.surplusLoanMoney }}元</span>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 还款信息 -->
      <div class="flow-sub-title">还款信息</div>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="借款日期" v-if="getIsShow('loanDateTime')">
            <span>{{ info.loanDateTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="借款截止日期" v-if="getIsShow('loanEndTime')">
            <span>{{ info.loanEndTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="首次还款日" v-if="getIsShow('firstDueDate')">
            <span>{{ info.firstDueDate }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="贷款利率" v-if="getIsShow('yearRate')">
            <span>{{ info.yearRate }}%</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="借款用途" v-if="getIsShow('loanUse')">
            <span>{{ info.loanUse }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="还款方式" v-if="getIsShow('repaymentType')">
            <span>{{ repaymentTypeText(info.repaymentType) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="贷款期限" v-if="getIsShow('loanDate')">
            <span>{{ info.loanDate }}月</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="还款频率" v-if="getIsShow('repaymentFrequency')">
            <span>按{{ rateListText(info.repaymentFrequency) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="还款日" v-if="getIsShow('repaymentDate')">
            <span>{{ info.repaymentDate }}号</span>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 授信信息 -->
      <div class="flow-sub-title">授信信息</div>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="授信金额" v-if="getIsShow('creditAmount')">
            <span>{{ info.creditAmount }}元</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="授信起始日期" v-if="getIsShow('creditBeginTime')">
            <span>{{ info.creditBeginTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="授信到期日期" v-if="getIsShow('creditEndTime')">
            <span>{{ info.creditEndTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="罚息利率" v-if="getIsShow('penaltyInterest')">
            <span>{{ info.penaltyInterest }}%</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="担保方" v-if="getIsShow('recognizorId')">
            <span>{{ info.recognizorName || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属机构" v-if="getIsShow('belongTenantId')">
            <span>{{ info.belongTenantName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="贷款用途" v-if="getIsShow('loanUse')">
            <span>{{ info.loanUse }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="归属人" v-if="getIsShow('belongUserId')">
            <span>{{ info.belongUserName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 收款信息  -->
      <div class="flow-sub-title">收款信息</div>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="收款账号" v-if="getIsShow('loanPayeeAccount')">
            <span>{{ info.loanPayeeAccount }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户银行" v-if="getIsShow('loanUserBank')">
            <span>{{ info.loanUserBank }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 付款信息  -->
      <div class="flow-sub-title">付款信息</div>
      <el-row :gutter="16">
        <template v-if="!isOffline">
          <el-col :span="12">
            <el-form-item label="支付通道" prop="payChannel">
              <RxkSelect :list="[{ label: '通道1', value: 10 }]" v-model="formState.payChannel" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款账户" prop="organCode">
              <div class="tw-flex tw-items-center tw-w-full">
                <RxkSelect
                  :list="accountList"
                  v-model="formState.organCode"
                  @change="changeAccount"
                />
                <div
                  class="tw-shrink-0 tw-ml-[16px] tw-text-[#666] tw-text-[14px] tw-flex tw-items-center"
                >
                  账户余额：{{ availableMoney ?? '-' }}
                  <el-icon
                    @click="refresh"
                    class="tw-ml-[8px] tw-cursor-pointer tw-text-[#5687FF]"
                    :class="`${refreshSpin ? 'animate-spin' : ''}`"
                  >
                    <Refresh />
                  </el-icon>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </template>
        <el-col :span="12">
          <el-form-item label="本次放款金额" prop="loanMoney">
            <Money
              v-model="formState.loanMoney"
              style="width: 100%"
              :data="{
                unit: '元',
                maxLength: 13,
                precisions: 2,
                setting: JSON.stringify({ web: { uppercase: true } })
              }"
              :renderConfig="{
                disabled: false
              }"
            />
          </el-form-item>
        </el-col>
        <template v-if="isOffline">
          <el-col :span="12">
            <el-form-item label="实际放款日期" prop="realRepaymentDate">
              <el-date-picker
                style="width: 100%"
                v-model="formState.realRepaymentDate"
                type="date"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款账户号" prop="payAccount">
              <RxkSelect
                style="width: 100%"
                filterable
                allow-create
                default-first-option
                :list="payAccountList"
                v-model="formState.payAccount"
                @change="changePayAccount"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款银行" prop="payBank">
              <RxkInput style="width: 100%" v-model="formState.payBank" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="deal-mortgage-file pip" label="附件" prop="accessory">
              <RxkUploadFile
                v-if="!loading"
                style="width: 100%"
                :limit="10"
                :max-size="500"
                accept=".jpg, .jpeg, .png"
                @handleSuccess="handleUploadSuccess"
                list-type="picture"
                :class="{ custome_upload: true }"
                ref="customeUpload"
                :fileList="formState.accessory"
              >
                <template #upload>
                  <div class="uplaod-tem">
                    <i class="iconfont icon-add" />
                    点击上传
                  </div>
                </template>
                <template #file="{ file }">
                  <div class="tw-w-[60px] tw-h-[60px]">
                    <CustomImg :imgPath="file?.response?.data[0]?.path">
                      <template v-slot:extra>
                        <div class="avatar">
                          <el-icon
                            @click.stop="imgViewer(file?.response?.data?.[0].path)"
                            :size="14"
                            color="#fff"
                          >
                            <View />
                          </el-icon>
                          <span class="division" />
                          <i
                            class="icon-shanshu iconfont icon"
                            @click.stop="handleRemoveFile(null, file)"
                          />
                        </div>
                      </template>
                    </CustomImg>
                  </div>
                </template>
              </RxkUploadFile>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
  </div>
</template>
<script lang="ts" setup>
import { cloneDeep } from '@/utils/tools'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { getBillApproveInfo } from '@/apis/erp/billMange'
import { loanList, repaymentTypes, rateList } from '@/views/erp/enums'
import {
  refreshWallet,
  selectConfirmedPayAccount,
  offlineLoanAccount
} from '@/apis/erp/loanManagement'
import Decimal from 'decimal.js'
import { map } from 'lodash-es'
import { RxkUploadFile } from '@/components/common/RxkUploadFile'
import CustomImg from '@/components/common/RxkUploadFile/src/avatar.vue'
import { RxkSelect } from '@/components/common/RxkSelect'
import { RxkInput } from '@/components/common/RxkInput'
import { useViewer } from '@/views/accountConfig/hook/useViewer'
import Money from '@/components/custom/form/components/money/index.vue'
import globalEnv from '@/configs'
const { open, setUrl } = useViewer(null)

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  formValue: {
    type: Object,
    default: () => ({})
  },
  permissions: {
    type: Object,
    default: () => ({})
  },
  tableCode: String,
  allShow: Boolean,
  isFinish: Boolean
})

function loanMoneyValidate(_rule: any, value: string, callback: any) {
  if (!value) {
    callback(new Error('请输入本次放款金额'))
  } else if (
    !isNullOrUndefOrEmpty(unref(availableMoney)) &&
    ~~unref(availableMoney) < Number(value) &&
    !isOffline.value
  ) {
    callback(new Error('账户余额不足，请准备足够资金后再试'))
  } else if (Number(value) < 500 && !isOffline.value) {
    callback(new Error('不能小于500'))
  } else if (Number(value) < 1 && isOffline.value) {
    callback(new Error('不能小于1'))
  } else if (Number(value) > info.value.residueLoanAmt) {
    callback(new Error('不能大于剩余可放款金额'))
  } else {
    callback()
  }
}

const loading = ref(true)
const formRef = ref()
const formState = ref<Recordable>({
  payChannel: '',
  organCode: '',
  loanMoney: '',
  realRepaymentDate: '',
  payAccount: '',
  payBank: '',
  accessory: []
})
const info = ref<any>({})
const rules: Recordable = {
  payChannel: [{ required: true, message: '请选择支付通道', trigger: 'change' }],
  organCode: [{ required: true, message: '请选择付款账户', trigger: 'change' }],
  loanMoney: [
    {
      required: true,
      validator: loanMoneyValidate,
      trigger: ['change', 'blur']
    }
  ],
  realRepaymentDate: [{ required: true, message: '请选择实际放款日期', trigger: 'change' }],
  payAccount: [{ required: true, message: '请输入付款账户号', trigger: 'change' }],
  payBank: [{ required: true, message: '请输入付款银行', trigger: 'change' }],
  accessory: [{ required: true, message: '请选择附件', trigger: 'change' }]
}
const isOffline = computed(() => {
  return props.formValue?.extendParam?.extendParam || info.value?.extendParam?.extendParam
})

// const isH5 = computed(() => {
//   return props.formValue.extendParam.isH5
// })

async function getDetails() {
  try {
    loading.value = true
    if (props.isFinish) {
      let formData = new FormData()
      formData.append('billId', props.id)
      const res = await getBillApproveInfo(formData)
      info.value = res || props.formValue
      formState.value = cloneDeep(props.formValue?.extendParam) || res
    } else {
      info.value = props.formValue
      formState.value = cloneDeep(props.formValue?.extendParam)
    }
    // 线下放款取值
    if (isOffline.value) {
      formatOffline()
    }
    loading.value = false
  } finally {
    loading.value = false
  }
}

function formatOffline() {
  let extendParam = cloneDeep(props.formValue?.extendParam?.extendParam)
  try {
    let list = JSON.parse(extendParam.accessory)
    extendParam.accessory = list.map((file: Recordable, index: number) => {
      return {
        ...file,
        uuid: new Date().getTime() + index
      }
    })
  } catch (e) {
    extendParam.accessory = []
  }
  formState.value = extendParam
  console.log(formState.value.accessory, '1688')
}

onMounted(async () => {
  await getDetails()
  await getAccountList()
})

async function handleSave() {
  try {
    const valid = await formRef.value.validate()
    if (!valid) {
      return {
        errorMessage: '必填项未填写或填写错误'
      }
    }
    let changeList: Recordable[] = []
    let data = unref(props.formValue) || {}
    let extendParam = isOffline.value ? data.extendParam.extendParam : data.extendParam
    formState.value.loanMoney = Number(formState.value.loanMoney)
    for (let key in formState.value) {
      if (formState.value[key] !== extendParam[key] && key !== 'accessory') {
        changeList.push({
          fieldSerial: key,
          oldValue: data[key],
          newValue: formState.value[key]
        })
      }
    }

    const params = cloneDeep(data)
    if (isOffline.value) {
      let formData = cloneDeep(formState.value)
      formData.accessory = JSON.stringify(formData.accessory)
      params.extendParam.extendParam = formData
    } else {
      params.extendParam = cloneDeep(formState.value)
    }

    return {
      changeList,
      data: params
    }
  } catch (e) {
    console.log(e)
    return {
      errorMessage: '必填项未填写或填写错误'
    }
  }
}

function productTypeText(value: number) {
  return loanList.find(item => item.value === value)?.label || ''
}

function repaymentTypeText(value: number) {
  return repaymentTypes.find(item => item.value === value)?.label || ''
}

function rateListText(value: number) {
  return rateList.find(item => item.value === value)?.label || ''
}

// 付款账户相关
const accountList = ref<any[]>([])
const availableMoney = ref<any>(null)
const orgCode = computed(() => {
  const accountObj: any = unref(accountList).find(
    (item: Recordable) => item.value === formState.value.organCode
  )
  return accountObj.value || ''
})

const changeAccount = () => {
  const accountObj: any = unref(accountList).find(
    (item: Recordable) => item.value === formState.value.organCode
  )
  availableMoney.value = new Decimal(accountObj?.availableMoney || 0)
    .add(accountObj.organMoney)
    .toNumber()
}

const refreshSpin = ref(false)
const refresh = () => {
  refreshSpin.value = true
  refreshWallet({ code: orgCode.value }).then((res: any) => {
    availableMoney.value = new Decimal(res.availableMoney).add(res.organMoney).toNumber()
    refreshSpin.value = false
  })
}

function getAccountList() {
  // 账户
  selectConfirmedPayAccount({ loanId: info.value.loanId }).then(res => {
    accountList.value = map(res, item => ({
      ...item,
      label: item.organName + item.organCode.slice(-4),
      value: item.organCode
    }))
    if (res.length && res.length === 1) {
      changeAccount()
    }
  })
  offlineLoanAccount({ loanId: info.value.loanId }).then(res => {
    payAccountList.value = map(res, item => ({
      ...item,
      label: item.bankAccount,
      value: item.bankAccount
    }))
    changePayAccount()
  })
}

// 线下放款相关
const payAccountList = ref<any[]>([])
function changePayAccount() {
  const account = payAccountList.value.find(el => el.value === formState.value.payAccount)
  if (account) {
    formState.value.payBank = account.bankName
  }
}

// 上传附件
const customeUpload = ref()

function handleUploadSuccess(_fileList: any, _file: any, res: Recordable) {
  res?.data?.forEach(() => {
    formState.value.accessory.push({
      name: res?.data?.[0]?.name,
      path: res?.data?.[0]?.path,
      uid: _file.uid
    })
  })
}
function handleRemoveFile(_fileList: any, file: Recordable) {
  let path = file?.response?.data?.[0].path
  formState.value.accessory.forEach((e: any, i: number) => {
    if (e.path === path) formState.value.accessory.splice(i, 1)
  })
  customeUpload.value.handleRemoveUploadFile(file)
}
const imgViewer = (url: string) => (setUrl([globalEnv.imgBaseUrl + url]), open())

// 是否展示此字段
function getIsShow(id: string) {
  if (props.allShow) return true
  return props.permissions && props.permissions[id]?.length
}

// 判断是否为只读
// function getIsTxt(id: string) {
//   // ['READ', 'WRITE', 'REQUIRED']
//   if (props.permissions?.[id]) {
//     if (
//       props.permissions?.[id]?.includes('WRITE') ||
//       props.permissions?.[id]?.includes('REQUIRED')
//     ) {
//       return false
//     }
//   }
//   return true
// }

defineExpose({
  handleSave
})
</script>
<style lang="scss" scoped>
.deal-mortgage-file {
  width: 100%;
  .uplaod-tem {
    width: 100%;
    height: 32px;
    border-radius: 4px;
    border: 1px dashed #dcdfe6;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #5687ff;
  }
  .el-upload-list {
    margin-top: 42px;
  }
  .el-form-item__content {
    display: unset;
    .file-item {
      display: block;
      color: #5687ff;
      cursor: pointer;
      .icon {
        margin-left: 12px;
      }
      a:hover {
        text-decoration: underline;
      }
    }
  }
}
.custome_upload {
  &.check {
    :deep(.el-upload--picture) {
      display: none;
    }
  }
  :deep(.el-upload-list--picture) {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    column-gap: 8px;
    margin-top: 8px !important;
  }
  :deep(.el-upload-list--picture .el-upload-list__item) {
    border: none;
    width: 60px;
    height: 60px;
    padding: 0;
    margin: 0;
  }
}
</style>
